export const HMOProviders = {
  ANTIDOTE: 'antidote',
  NIRVANA: 'nirvana',
}
